import { TFeature } from '../../../../../common/types/map';

// Сигнатура фичи для решения о пересборке пинов: id и поля объявлений, которые влияют
// на вёрстку балуна (цена, просмотренность, избранное, иконка) и на состав.
// Считается по всем объявлениям, а не по первому: у мультипина изменение любого из них
// (например, добавление третьего в избранное) обязано перерисовать пин.
export function getFeatureSignature(feature: TFeature): string {
  const offers = feature.properties.offers
    .map(
      ({ cianId, averagePricePerDay, isViewed, isFavorite, icon }) =>
        `${cianId}:${averagePricePerDay}:${isViewed}:${isFavorite}:${icon ?? ''}`,
    )
    .join(',');

  return `${feature.id}:${offers}`;
}
